<template>
    <div class="roll-card" :class="{calc: !height, open}">
        <div class="title" @click="open = !open">
            <div class="about">
                <h4>{{ data.name }}</h4>
                <div class="original-price" v-if="data.originalPrice">{{ data.originalPrice | price }}&nbsp;&#8381;
                </div>
                <div class="price">{{ data.price | price }}&nbsp;&#8381;</div>
            </div>
            <img class="arrow" src="@/assets/icons/arrow_head.svg" alt="">
        </div>
        <div class="content" ref="content" :style="styleContent">
            <ul>
                <li v-for="item of permissionsList" v-html="filterText(item)"></li>
            </ul>
            <tag color="green">Остается после вайпа</tag>
        </div>
    </div>
</template>

<script>
import tag from '@/elements/tag.vue'
import roleToColorMatcher from "@/mixins/roleToColorMatcher";

export default {
    name: "roll_card",
    mixins: [roleToColorMatcher],
    components: {
        tag,
    },
    props: {
        data: Object
    },
    data: () => ({
        open: true,
        height: 0
    }),
    mounted() {
        this.$nextTick(() => {
            this.height = this.$refs.content.offsetHeight;
            this.open = false;
        });
    },
    computed: {
        styleContent() {
            if(this.open && this.height) {
                return {
                    'max-height': `${this.height}px`
                }
            }
        },
        permissionsList() {
            if (!this.data.permissions) return [];
            return this.data.permissions;
        }
    },
    methods: {
        filterText(text) {
            return this.prefixWrapper(this.commandWrapper(text.replace(/(<([^>]+)>)/ig, "")));
        },
        prefixWrapper(text) {
            return text.replace(/\[([^\]]*)\]/g, this.prefixReplacer)
        },
        prefixReplacer(_, role) {
            return `<span class="gray">[<span class="${this.matchRoleToColor(role)}">${role}</span>]</span>`
        },
        commandWrapper(text) {
            return text.replace(/(\/[^\s]*)/g, '<span class="blue">$1</span>')
        },
    },
    filters: {
        price(v) {
            const price = parseFloat(v);
            return isNaN(price) ? v : price.toLocaleString();
        }
    }
}
</script>

<style lang="scss">
.roll-card {
    background-color: $bg_light_plus;
    margin-bottom: 4px;
    border-radius: 4px;
    transition: all 0.25s, opacity 0.25s ease 0.25s;

    &.calc {
        opacity: 0;
    }

    & > * {
        padding: 0 16px;

    }

    .title {
        cursor: pointer;
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .about {
            display: flex;
            align-items: center;

            h4 {
                margin-right: 8px;
                font-weight: bold;
                font-size: 16px;
                line-height: 19px;
                color: white;
            }

            .original-price {
                margin-right: 8px;
                text-decoration-line: line-through;
            }

            .price {
                font-weight: 500;
                font-size: 16px;
                line-height: 19px;
                color: $blue;
            }
        }

        img.arrow {
            user-select: none;
            transition: $transition;
        }
    }

    .content {
        max-height: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        transition: all 0.25s;

        ul {
            margin-bottom: 15px;
            @include mobile {
                margin-bottom: 12px;
            }

            li {
                margin-bottom: 8px;
                font-weight: 500;
                font-size: 14px;
                line-height: 17px;
                color: white;

                &::before {
                    content: '•';
                    color: $text_gray;
                    font-weight: 700;
                    padding-right: 4px;
                }

                span {
                    font-weight: bold;
                    line-height: 18px;
                }

                span {

                }

                span.gray {
                    color: #48515E;
                }

                span.blue {
                    color: $blue;
                }

                span.green {
                    color: $green;
                }

                span.orange {
                    color: $orange
                }

                span.red {
                    color: $red
                }

                span.purple {
                    color: $purple
                }

                span.pink {
                    color: $pink
                }

                span.aqua {
                    color: $aqua
                }
            }
        }
    }

    &.open {
        img.arrow {
            transform: rotate(-90deg);
        }

        .content {
            max-height: unset;
            padding-top: 4px;
            padding-bottom: 16px;
        }
    }
}
</style>
